<template>
  <div ref="layout" class="page-form">
    <h3 class="title">发货单详情</h3>

    <div class="form-container">
      <errors-list :errors="errorList" />
      <div class="tools" style="display: flex;justify-content: space-between;">
        <div style="display: flex">
          <form-button style="margin-right: 10px" @click="$router.back()">返回</form-button>

          <btky-header
            v-if="isEdit"
            :form-data="wlyApplyForGoodsPo"
            :process-key="processKey"
            is-search
            @formDataSave="validate"
            @validate="validate"
          />
        </div>
        <form-button @click="printPage">打印</form-button>
      </div>
      <el-form
        ref="form"
        inline
        size="mini"
        label-width="100px"
        :model="wlyApplyForGoodsPo"
      >
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="要货单号">
              <el-input
                v-model="wlyApplyForGoodsPo.wantCode"
                placeholder="自动生成"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="订单客户">
              <el-input v-model="wlyApplyForGoodsPo.customerName" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="开票客户">
              <el-input
                v-model="wlyApplyForGoodsPo.billCustomer"
                placeholder="请输入"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="计划类型" prop="planType">
              <el-select v-model="wlyApplyForGoodsPo.planType" disabled>
                <el-option
                  v-for="item in selectDataOptions['A0002']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="制单票据类型">
              <el-select v-model="wlyApplyForGoodsPo.noticeSheetType" disabled>
                <el-option
                  v-for="item in selectDataOptions['A0022']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 取经销商该年度签署合同渠道、如果不是配额计划，渠道为空 -->
          <el-col :lg="8" :md="12">
            <el-form-item prop="channelsType" label="渠道类型">
              <el-select v-model="wlyApplyForGoodsPo.channelsType" disabled>
                <el-option
                  v-for="item in selectDataOptions['A0054']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="配额年度" prop="quotasYear">
              <el-input :value="wlyApplyForGoodsPo.quotasYear" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="营销中心">
              <el-input
                v-model="wlyApplyForGoodsPo.saleCenterName"
                placeholder=""
                type="text"
                clearable
                disabled
              />
              <!-- <el-select
                v-model="wlyApplyForGoodsPo.saleCenter"
                placeholder="请选择"
                type="select"
                clearable
                disabled
              >
                <el-option
                  v-for="item in selectDataOptions['orgList']"
                  :key="item.zzfld00001h"
                  :label="item.mc_short"
                  :value="item.zzfld00001h"
                />
              </el-select> -->
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="紧急程度" prop="significance">
              <el-select v-model="wlyApplyForGoodsPo.significance" disabled>
                <el-option
                  v-for="item in selectDataOptions['Significance']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="是否瓶储" prop="isPcj">
              <el-select v-model="wlyApplyForGoodsPo.isPcj" disabled>
                <el-option :value="0" label="否" />
                <el-option :value="1" label="是" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-show="wlyApplyForGoodsPo.isPcj == 1" :lg="8" :md="12">
            <el-form-item
              label="瓶储截止日期"
            >
              <el-date-picker
                v-model="wlyApplyForGoodsPo.saveEnddate"
                type="date"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12" v-if="isCxj">
            <el-form-item label="是否存新酒" prop="isCxj">
              <el-select v-model="wlyApplyForGoodsPo.isCxj" disabled>
                <el-option
                  v-for="item in selectDataOptions['B0099']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-show="wlyApplyForGoodsPo.isCxj == 1" :lg="8" :md="12">
            <el-form-item
              label="储存期限(月)"
              :required="wlyApplyForGoodsPo.isCxj == 1 ? true : false"
            >
              <el-input
                v-model="wlyApplyForGoodsPo.savedMonths"
                placeholder="请输入"
                type="text"
                clearable
                :disabled="wlyApplyForGoodsPo.subProcUnitId !== 'work'"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12" v-if="wlyApplyForGoodsPo.demandType=='ZDZG'">
            <el-form-item label="要货单类型" prop="demandType">
              <el-select v-model="wlyApplyForGoodsPo.demandType" placeholder="" disabled>
                <el-option
                  v-for="item in selectDataOptions['A0081']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12" v-if="wlyApplyForGoodsPo.demandType=='ZDZG'">
            <el-form-item label="收货终端" prop="terminalName">
              <wly-input
                v-model="wlyApplyForGoodsPo.terminalName"
                input-type="terminal"
                disabled
              />
            </el-form-item>
          </el-col>
        </el-row>

        <div class="table-container" style="padding: 0">
          <TableCommon title="安吉发运信息" :custome-config="() => vxeShowCustom('xTable4')">
            <vxe-grid
              ref="xTable4"
              class="table-block"
              border
              :highlight-hover-row="true"
              resizable
              :show-overflow="true"
              align="center"
              size="mini"
              :empty-render="{ name: 'NotData' }"
              :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
              :edit-config="{ trigger: 'manual', mode: 'row' }"
              :columns="ajInfo.columns"
              :data="ajInfo.data"
            >
              <template #originalDrawing="{row}">
                <a v-if="row.originalDrawing" class="blue" @click="showImages(row.originalDrawing)">查看</a>
                <span v-else>无</span>
              </template>
            </vxe-grid>
          </TableCommon>
          <TableCommon title="要货明细" :custome-config="() => vxeShowCustom('xTable')">
            <vxe-grid
              ref="xTable"
              class="table-block"
              border
              :highlight-hover-row="true"
              resizable
              :show-overflow="true"
              height="auto"
              max-height="200"
              align="center"
              size="mini"
              :checkbox-config="{ highlight: true }"
              :radio-config="{ highlight: true }"
              :empty-render="{ name: 'NotData' }"
              :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
              :edit-config="{ trigger: 'manual', mode: 'row' }"
              :columns="gridOptions.columns"
              :data="gridOptions.data"
            >
              <!-- <template #toolbar /> -->
              <template v-for="item in gridOptions.columns" #[item.field]="{ row }">
                <div :key="item.field">
                  <el-input
                    v-if="
                      gridOptions.columnsFieldTypes[item.field] == 'input' &&
                        item.field === 'baseAuditQuantity' &&
                        wlyApplyForGoodsPo.subProcUnitId === 'base'
                    "
                    v-model.number="row[item.field]"
                    :disabled="!isEdit"
                    size="mini"
                  />
                  <el-input
                    v-else-if="
                      gridOptions.columnsFieldTypes[item.field] == 'input' &&
                        item.field === 'warAuditQuantity' &&
                        wlyApplyForGoodsPo.subProcUnitId === 'warZone'
                    "
                    v-model.number="row[item.field]"
                    :disabled="!isEdit"
                    size="mini"
                  />
                  <el-input
                    v-else-if="
                      gridOptions.columnsFieldTypes[item.field] == 'input' &&
                        item.field === 'salecenterAuditQuantity' &&
                        wlyApplyForGoodsPo.subProcUnitId === 'work'
                    "
                    v-model.number="row[item.field]"
                    :disabled="!isEdit"
                    size="mini"
                  />

                  <el-input
                    v-else-if="
                      gridOptions.columnsFieldTypes[item.field] == 'input' &&
                        item.field === 'remark'
                    "
                    v-model="row[item.field]"
                    :disabled="!isEdit"
                    size="mini"
                  />
                  <span v-else-if="item.field === 'brandBq'">{{
                    filterDictionary(row.brandBq, 'A0019')
                  }}</span>
                  <span v-else-if="item.field === 'inventoryRate'">{{
                    handleRate(row)
                  }}</span>
                  <span v-else>{{ row[item.field] }}</span>
                </div>
              </template>
            </vxe-grid>
          </TableCommon>

          <TableCommon
            v-if="isApplyForGoodsDetailShow == '1'"
            title="占用发票明细"
            :custome-config="() => vxeShowCustom('xTable2')"
          >
            <vxe-grid
              ref="xTable2"
              class="table-block"
              border
              :highlight-hover-row="true"
              resizable
              :show-overflow="true"
              height="auto"
              max-height="240"
              align="center"
              size="mini"
              :empty-render="{ name: 'NotData' }"
              :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
              :edit-config="{ trigger: 'manual', mode: 'row' }"
              :columns="gridOptions3.columns"
              :data="gridOptions3.data"
            />
          </TableCommon>

          <common-title title="收货信息" />
          <el-row :gutter="24">
            <!-- 是 分流经销商 分流收货单位 必填 -->
            <el-col :lg="8" :md="12">
              <el-form-item label="是否分流：">
                <el-select v-model="wlyApplyForGoodsPo.isShunt" disabled>
                  <el-option
                    v-for="item in selectDataOptions['B0099']"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 开票客户的分流经销商 -->
            <template v-if="wlyApplyForGoodsPo.isShunt === '1'">
              <el-col :lg="8" :md="12">
                <el-form-item label="分流经销商">
                  <el-input
                    v-model="wlyApplyForGoodsPo.shuntDealer"
                    placeholder="请输入"
                    type="text"
                    suffix-icon="el-icon-more"
                    clearable
                    disabled
                    @focus="showClientDialog($event, 'client')"
                  />
                </el-form-item>
              </el-col>
              <el-col :lg="8" :md="12">
                <el-form-item label="分流渠道类型">
                  <el-select v-model="wlyApplyForGoodsPo.shuntChannelsType" disabled>
                    <el-option
                      v-for="item in selectDataOptions['A0054']"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 开票客户的分流经销商 -->
              <el-col :lg="8" :md="12">
                <el-form-item label="分流收货单位">
                  <el-input
                    v-model="wlyApplyForGoodsPo.shuntReceiveUnitName"
                    suffix-icon="el-icon-more"
                    clearable
                    disabled
                    @focus="showClientDialog($event, 'contact')"
                  />
                </el-form-item>
              </el-col>
            </template>
            <!-- 默认订单客户 -->
            <el-col :lg="8" :md="12">
              <el-form-item :label="wlyApplyForGoodsPo.ggtg === 1 ? '喷码内容' : '喷码单位'">
                <el-input
                  v-model="wlyApplyForGoodsPo.spurtCodeUnitName"
                  placeholder="请输入"
                  type="text"
                  clearable
                  disabled
                  suffix-icon="el-icon-more"
                  @focus="showClientDialog($event, 'client')"
                />
              </el-form-item>
            </el-col>
            <!-- 客户的收货地址 -->
            <el-col :lg="8" :md="12">
              <el-form-item :label="wlyApplyForGoodsPo.demandType=='ZDZG' ? '收货终端' :'收货单位'" prop="receiveUnitName">
                <el-input
                  v-model="wlyApplyForGoodsPo.receiveUnitName"
                  placeholder="请输入"
                  type="text"
                  clearable
                  disabled
                  suffix-icon="el-icon-more"
                  @focus="showClientDialog($event, 'contact')"
                />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="联系电话">
                <el-input
                  v-model="wlyApplyForGoodsPo.contactNumber"
                  placeholder="请输入"
                  type="text"
                  clearable
                  disabled
                />
              </el-form-item>
            </el-col>
            <el-col :lg="16" :md="12">
              <el-form-item label="收货地址" prop="receiveAddress">
                <el-input
                  v-model="wlyApplyForGoodsPo.receiveAddress"
                  placeholder="请输入"
                  type="text"
                  clearable
                  disabled
                />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="收货联系人">
                <el-input
                  v-model="wlyApplyForGoodsPo.contacPerson"
                  placeholder="请输入"
                  type="text"
                  clearable
                  disabled
                />
              </el-form-item>
            </el-col>
            <!-- 是 备注必填 -->
            <el-col :lg="8" :md="12" v-if="wlyApplyForGoodsPo.demandType!='ZDZG'">
              <el-form-item label="是否自提">
                <el-checkbox
                  v-model="wlyApplyForGoodsPo.selfacceptance"
                  :true-label="1"
                  :false-label="0"
                  disabled
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注">
                <el-input
                  v-model="wlyApplyForGoodsPo.remark"
                  placeholder="请输入"
                  resize="none"
                  :autosize="{ minRows: 2, maxRows: 2 }"
                  type="textarea"
                  clearable
                  disabled
                />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 渠道类型选择KA时 -->
          <common-title v-if="wlyApplyForGoodsPo.channelsType == 'K'" title="KA卖场信息" />
          <el-row v-if="wlyApplyForGoodsPo.channelsType == 'K'" :gutter="24">
            <el-col :lg="8" :md="12">
              <el-form-item label="卖场全称">
                <el-select
                  v-model="wlyApplyForGoodsPo.kaStoreFullname"
                  placeholder="请选择"
                  clearable
                  disabled
                  @focus="showClientDialog($event, 'ka')"
                />
              </el-form-item>
            </el-col>
            <el-col :lg="8" :md="12">
              <el-form-item label="卖场简称">
                <el-input v-model="wlyApplyForGoodsPo.kaStoreShortName" disabled />
              </el-form-item>
            </el-col>
            <!-- 订单客户所在区域 -->
            <el-col :lg="8" :md="12">
              <el-form-item label="卖场区域">
                <el-input v-model="wlyApplyForGoodsPo.kaStoreArea" disabled />
              </el-form-item>
            </el-col>
          </el-row>

          <TableCommon title="附件" :custome-config="() => vxeShowCustom('xTable3')">
            <vxe-grid
              ref="xTable3"
              class="table-block"
              border
              :highlight-hover-row="true"
              resizable
              :show-overflow="true"
              align="center"
              size="mini"
              :empty-render="{ name: 'NotData' }"
              :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
              :edit-config="{ trigger: 'manual', mode: 'row' }"
              :columns="gridOptions2.columns"
              :data="gridOptions2.data"
            >
              <template #fileName="{row}">
                <span class="blue" @click="dowLoadFile(row)">{{ row.fileName }}</span>
              </template>
              <template #createdDate="{row}">
                <span>{{ row.creator.createdDate }}</span>
              </template>
            </vxe-grid>
          </TableCommon>

          <TableCommon v-if="!isEdit" style="margin-top: 10px" title="流程轨迹" :show-custome="false">
            <el-table
              :data="tablePathData.data"
              border
              :header-cell-style="{
                background: '#f2f8fe',
                color: '#333',
                fontSize: '12px',
                fontWeight: '600',
                lineHeight: '27px',
                padding: 0
              }"
              :row-style="{
                fontSize: '12px'
              }"
              :cell-style="{
                padding: '5px 0',
                textAlign: 'left'
              }"
            >
              <el-table-column
                prop="subProcUnitName"
                label="环节描述"
                width="160"
                :formatter="(r,c,value) => {
                  const text = value || r.name || ''
                  return text.replace(/审批/g, '')
                }"
              />
              <el-table-column
                prop="handler"
                label="处理人"
                width="200"
                :formatter="(r,c,value) => value.split('.')[1]"
              />
              <el-table-column
                prop="phone"
                label="电话"
                width="120px"
              />
              <el-table-column
                  prop="opinion"
                  label="情况说明"
              />
              <el-table-column
                prop="result"
                label="处理结果"
                width="100px"
                :formatter="(r,c,value) => value === 1 || value === '1' ? '已阅' : ''"
              />
              <el-table-column
                prop="startTime"
                label="开始时间"
                width="150px"
              />
              <el-table-column
                prop="endTime"
                label="结束时间"
                width="150px"
              />
              <el-table-column
                prop="duration"
                label="耗时"
                width="70px"
                :formatter="(r,c,value) => value ? value + 'h' : value"
              />
              <el-table-column
                prop="statusName"
                label="状态"
                width="90px"
              />
            </el-table>
          </TableCommon>
          <purchase-footer v-if="isEdit" :form-data="wlyApplyForGoodsPo" @successAction="successAction" />

        </div>
      </el-form>

    </div>
    <el-image-viewer
      v-if="showViewer"
      :on-close="()=>{showViewer = false}"
      :url-list="viewers"
    />
    <el-dialog
      v-dialogDrag
      :visible.sync="showDialog"
      title="发货申请单"
      width="70%"
      top="5vh"
    >
      <iframe :src="url" frameborder="0" style="width: 100%;height: 600px" />
    </el-dialog>
  </div>
</template>
<script>
import { wantgoodsFindById, apiFindAnJiOrderStatus, apiDeliveryPrint, queryApprovalHistoryByBizIdPhone,thirdRealTimeInventory } from '@/api/applyForGoods/index'
//import { queryApprovalHistoryByBizId } from '@/api/flowHander'
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { mapGetters } from 'vuex'
import { filterDictionary } from '@/utils/index'
import { queryFiles, apiAttachmentDownFile } from '@/api/common'
import { download } from '@/utils/frontExport'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
  components: {ElImageViewer},
  data() {
    return {
      processKey: 'wantGoods',
      showDialog: false,
      url: '',
      showViewer: false,
      viewers: [],
      errorList: [],
      wlyApplyForGoodsPo: {
        id: '',
        taskId: '',
        bizId: '',
        status: 0,
        billCode: '',
        billStatus: 'E001',
        billCustCode: '',
        billCustomer: '',
        shuntDealer: '',
        clientId: '',
        brandBq: '',
        ticketDetailId: '',
        remark: '',
        customerCode: '',
        customerName: '',
        noticeSheetType: '',
        receiveUnitCode: '',
        channelsType: '',
        quotasYear: '',
        saleCenter: '', // 营销单元
        isShunt: '0',
        significance: 'normal',
        kaStoreShortName: '',
        kaStoreFullname: '',
        kaStoreArea: '',
        acceptUnitType: '',
        receiveUnitName: '',
        receiveAddress: '',
        contacPerson: '',
        contactNumber: '',
        shuntChannelsType: '',
        shuntReceiveUnitCode: '',
        shuntReceiveUnitName: '',
        spurtCodeUnit: '',
        spurtCodeUnitName: '',
        selfacceptance: 0,
        ggtg: '0',
        transferId: '',
        sourceType: '1',
        saveEnddate: '',
        subProcUnitId: '',
        savedMonths: ''
      },
      selectDataOptions: {},
      gridOptions: {
        columns: [
          {
            field: 'brandTextView',
            title: '存货分类',
            width: 120
          },
          {
            field: 'productDesc',
            title: '产品描述',
            width: 300
          },
          {
            field: 'yearSalePlanQty',
            title: '年度配额计划量(件)',
            width: 90
          },
          {
            field: 'undeliveredQuantity',
            title: '未发货量(件)',
            width: 90
          },
          {
            field: 'availableBot',
            title: '未发货量(瓶)',
            width: 90
          },
          {
            field: 'wantQuantity',
            title: '本次要货量(件)',
            width: 90
          },
          {
            field: 'wantQuantity',
            title: '渠道协助量',
            width: 90
          },
          {
            field: 'baseAuditQuantity',
            title: '基地协助量',
            width: 90,
            visible: false,
            slots: { default: 'baseAuditQuantity' }
          },
          {
            field: 'warAuditQuantity',
            title: '战区协助量',
            width: 90,
            visible: false,
            slots: { default: 'warAuditQuantity' }
          },
          {
            field: 'salecenterAuditQuantity',
            title: '销售内勤协助量',
            width: 110,
            visible: false,
            slots: { default: 'salecenterAuditQuantity' }
          },
           {
            field: 'yearSalePlanQty',
            title: '年销售计划量',
            width: 96,
            visible: true
          },
          {
            field: 'monthSalePlanQty',
            title: '月销售计划量',
            width: 96,
            visible: true
          },
          {
            field: 'monthDeliverQty',
            title: '月累计发货',
            width: 96,
            visible: true
          },
          {
            field: 'yearDeliverQty',
            title: '年累计发货',
            width: 96,
            visible: true
          },
          {
            field: 'monthAuditQty',
            title: '当月协助量',
            width: 90,
            visible: true
          },
          {
            field: 'stockQuantity',
            title: '库存量',
            width: 70
          },
          {
            field: 'realInventoryQty',
            title: '实时库存量',
            width: 80
          },
          {
            field: 'roadQuantity',
            title: '在途量',
            width: 70
          },
          {
            field: 'auditShipmentQuantity',
            title: '已审在发运量',
            width: 100
          },
          {
            field: 'annualInputQty',
            title: '全年投放量',
            width: 100
          },
          {
            field: 'inventoryRate',
            title: '库存率',
            width: 100,
            slots: { default: 'inventoryRate' }
          },
          {
            field: 'remark',
            title: '备注',

            slots: { default: 'remark' }
          }
        ],
        data: [],
        columnsFieldTypes: {
          remark: 'input',
          wantQuantity: 'input',
          baseAuditQuantity: 'input',
          warAuditQuantity: 'input',
          salecenterAuditQuantity: 'input'
        }
      },
      gridOptions3: {
        columns: [
          { type: 'seq', title: '序号', filed: 'seq', width: 48 },
          {
            field: 'custName',
            title: '开票客户',
            width: 200
          },
          {
            field: 'invoiceDate',
            title: '开票日期',
            width: 110
          },
          {
            field: 'planType',
            title: '计划类型',
            width: 110
          },
          {
            field: 'invoId',
            title: '发票号',
            width: 110
          },
          {
            field: 'productText',
            title: '产品名称',
            width: 250
          },
          {
            field: 'netPrice',
            title: '含税单价',
            width: 80
          },
          {
            field: 'netValue',
            title: '价税合计（折扣前）',
            width: 100
          },
          {
            field: 'invoiceQty',
            title: '开票总量(件)',
            width: 100
          },
          {
            field: 'useBot',
            title: '开票总量(瓶)',
            width: 100
          },
          {
            field: 'datum',
            title: '占用时间',
            width: 140
          },
          {
            field: 'occupyQty',
            title: '本次占用(件)',
            width: 100
          },
          {
            field: 'occupyQtyBot',
            title: '本次占用(瓶)',
            width: 100
          },
          {
            field: 'zcustomName',
            title: '定制名称',
            width: 80
          }
        ],
        data: []
      },
      gridOptions2: {
        columns: [
          {
            field: 'fileName',
            title: '附件名称',
            slots: { default: 'fileName' }
          },
          {
            field: 'fileKind',
            title: '附件类型'
          },
          {
            field: 'fileSize',
            title: '大小'
          },
          {
            field: 'createdDate',
            title: '上传时间',
            slots: { default: 'createdDate' }
          }
        ],
        data: []
      },
      ajInfo: {
        columns: [
          { title: '运单号', field: 'logisticno',width: 200 },
          { title: '当前状态', field: 'orderStatusTextView',width: 160 },
          { title: '时间', field: 'date',width: 200 },
          { title: '发运数量', field: 'actDeliveryQty',width: 200},
          { title: '签收图片', field: 'originalDrawing', slots: { default: 'originalDrawing' }}
        ],
        data: []
      },
      tablePathData: {
        columns: [
          { title: '环节描述', field: 'subProcUnitName', formatter: ({ cellValue, row }) => cellValue || row.name },
          { title: '处理人', field: 'handler', formatter: ({ cellValue }) => { return cellValue.split('.')[1] } },
          { title: '处理结果', field: 'resultTextView' },
          { title: '意见', field: 'opinion' },
          { title: '任务类型', field: 'taskKindTextView' },
          { title: '开始时间', field: 'startTime' },
          { title: '结束时间', field: 'endTime' },
          { title: '耗时（小时）', field: 'duration' },
          { title: '状态', field: 'statusName' }
        ],
        data: []
      }
    }
  },
  computed: {
    isCxj(){
      return this.role.CXJ_ROLE === 'X'
    },
    // 审批、单据查询 出现
    isApplyForGoodsDetailShow() {
      return this.$route.query.isSearchPage
    },
    ...mapGetters(['userInfo', 'role']),
    isEdit() {
      return +this.wlyApplyForGoodsPo.executorPersonCode == +this.role.USER_BP
    }
  },
  watch: {
    // 'wlyApplyForGoodsPo.channelsType': {
    //   handler(val, old) {
    //     if (val === 'T') {
    //       this.gridOptions.columns.push(...TColumns)
    //     }
    //     if (old === 'T') {
    //       this.gridOptions.columns.splice(-3)
    //     }
    //   }
    // }
  },
  created() {
    this.init()
    // 如果是从代办中进入的申请单，直接查询已保存的发货申请单
    this.getToGoodsPo()
    this.flowPath()
  },

  methods: {
    handleRate(row){
      return row.annualInputQty && row.stockQuantity ? (row.stockQuantity/row.annualInputQty* 100).toFixed(2) + '%' : 0
    },
    filterDictionary,
    // 提交成功，退回成功的回调
    successAction() {
      this.getToGoodsPo()
      this.flowPath()
    },
    flowPath() {
      queryApprovalHistoryByBizIdPhone({ bizId: this.$route.query.id })
        .then(res => {
          if (res.data) {
            this.tablePathData.data = res.data.Rows.filter(v => v.statusName !== '已取消')
            // if (res.data.Rows.every(v => v.statusId === 'completed')) {
              this.gridOptions.columns = this.gridOptions.columns.map(v => {
                if (
                  v.field === 'baseAuditQuantity' ||
                  v.field === 'warAuditQuantity' ||
                  v.field === 'salecenterAuditQuantity'
                ) {
                  v.visible = true
                }
                return v
              })
            // }
          }
        })
        .catch(() => {})
    },
    printPage() {
      apiDeliveryPrint({ wantGoodsId: this.wlyApplyForGoodsPo.id }).then(res => {
        this.showDialog = true
        const blob = new Blob([res.data], { type: 'application/pdf' })
        this.url = '/static/pdf/web/viewer.html?file=' + URL.createObjectURL(blob)
      })
    },
    init() {
      // 计划类型
      this.getSelectDictDataOrigin('A0002')
      // 通知单类型
      this.getSelectDictDataOrigin('A0022')
      // 是否分流
      this.getSelectDictDataOrigin('B0099')
      // 渠道类型
      this.getSelectDictDataOrigin('A0054')
      // 存货分类
      this.getSelectDictDataOrigin('A0019')
      // 要货类型
      this.getSelectDictDataOrigin('A0081')
      // 发货紧急程度
      this.getSelectDictDataOrigin('Significance')
    },
    showImages(pic) {
      const urls = (pic || '')
        .split(',')
        .map(s => s.trim())
        .filter(Boolean)
      if (!urls.length) {
        return this.$message.error('没有图片！')
      }
      if (urls.length === 1) {
        window.open(urls[0], '_blank')
        return
      }
      const win = window.open('', '_blank')
      if (!win) {
        return this.$message.error('浏览器拦截了弹窗')
      }
      const html = `
        <!doctype html>
        <html>
          <head>
            <meta charset="utf-8">
            <title>回单图片</title>
            <style>
              body { margin:0; padding:16px; font-family:system-ui,-apple-system,Segoe UI,Roboto; }
              .grid { display:flex; flex-wrap:wrap; gap:12px; }
              .item { width:calc(50% - 12px); box-sizing:border-box; }
              .item img { width:100%; height:auto; border:1px solid #eee; border-radius:4px; display:block; }
              .link { margin-top:6px; word-break:break-all; }
              .link a { color:#2d92d6; text-decoration:none; }
              h3 { margin:0 0 12px 0; }
            </style>
          </head>
          <body>
            <h3>回单图片</h3>
            <div class="grid">
              ${urls.map(u => `
                <div class="item">
                  <a href="${u}" target="_blank" rel="noopener noreferrer">
                    <img src="${u}" />
                  </a>
                  <div class="link">
                    <a href="${u}" target="_blank" rel="noopener noreferrer">${u}</a>
                  </div>
                </div>
              `).join('')}
            </div>
          </body>
        </html>
      `
      win.document.open()
      win.document.write(html)
      win.document.close()
    },
    // 根据id查询发货单信息
    getToGoodsPo() {
      wantgoodsFindById({ id: this.$route.query.id }).then(response => {
        this.wlyApplyForGoodsPo = response.data
        this.wlyApplyForGoodsPo.bizId = response.data.id
        // this.wlyApplyForGoodsPo.taskId = this.$route.query.taskId
        this.wlyApplyForGoodsPo.quotasYear = response.data.quotasYear + ''
        this.wlyApplyForGoodsPo.isShunt = response.data.isShunt + ''
        this.gridOptions.data = this.wlyApplyForGoodsPo.wantGoodsDetailList
        if(this.wlyApplyForGoodsPo.wantGoodsDetailList[0].batchNumber){
          this.gridOptions.columns.splice(this.gridOptions.columns.length - 1, 0, {
            field: 'batchNumber',
            title: '批次号',
            width: 120,
            slots: { default: 'batchNumber' }
          })
        }
        this.gridOptions3.data = this.wlyApplyForGoodsPo.invoiceUsedList
        this.getFiles()
        this.getAjInfo()

        // 基地审批
        if (this.wlyApplyForGoodsPo.subProcUnitId === 'base') {
          this.gridOptions.columns = this.gridOptions.columns.map(v => {
            if (v.field === 'baseAuditQuantity') {
              v.visible = true
              v.width = 120
            }
            return v
          })
          this.gridOptions.data.forEach(item => {
            this.$set(item, 'baseAuditQuantity', item.wantQuantity)
          })
        } else if (this.wlyApplyForGoodsPo.subProcUnitId === 'warZone') {
          this.gridOptions.columns = this.gridOptions.columns.map(v => {
            if (v.field === 'baseAuditQuantity' || v.field === 'warAuditQuantity') {
              v.visible = true
            }
            return v
          })
          this.gridOptions.data.forEach(item => {
            // 如果基地数量为空就取申请数量
            if (!item.baseAuditQuantity) {
              item.baseAuditQuantity = item.wantQuantity
            }
            this.$set(item, 'warAuditQuantity', item.baseAuditQuantity)
          })
        } else if (['work', 'center'].includes(this.wlyApplyForGoodsPo.subProcUnitId)) {
          this.gridOptions.columns = this.gridOptions.columns.map(v => {
            if (
              v.field === 'baseAuditQuantity' ||
              v.field === 'warAuditQuantity' ||
              v.field === 'salecenterAuditQuantity'
            ) {
              v.visible = true
            }
            return v
          })
          this.gridOptions.data.forEach(item => {
            // 如果基地数量为空就取申请数量
            if (!item.baseAuditQuantity) {
              item.baseAuditQuantity = item.wantQuantity
            }
            if (!item.warAuditQuantity) {
              item.warAuditQuantity = item.baseAuditQuantity
            }
            this.$set(item, 'salecenterAuditQuantity', item.warAuditQuantity)
          })
        }

        // 如果是渠道类型 是K, 由于审批流程没有战区审批，在内勤审批进入后，把基地审批的数据 赋值给战区协助量
        if (this.wlyApplyForGoodsPo.subProcUnitId === 'work' && (this.wlyApplyForGoodsPo.channelsType === 'K' || this.wlyApplyForGoodsPo.channelsType === 'D')) {
          this.gridOptions.data[0].warAuditQuantity = this.gridOptions.data[0].baseAuditQuantity
        }
        // 渠道类型
        // this.getChannelType()
        this.$refs.xTable.refreshColumn()
        // 查询在实时库存量
        this.thirdRealTimeInventory()
      })
    },
    // 查询在实时库存量
    async thirdRealTimeInventory() {
      try {
        const params = {
          "dealerId": this.wlyApplyForGoodsPo.customerCode,
          "productId": this.wlyApplyForGoodsPo.wantGoodsDetailList[0].productCode,
          "channel": this.wlyApplyForGoodsPo.channelsType,
        }
        const res = await thirdRealTimeInventory(params)
        if (res.status === 2){
          this.gridOptions.data[0].realInventoryQty = 0
        }else{
          this.gridOptions.data[0].realInventoryQty = res.data.inventoryQuantity
        }
      } catch (error) {
      }
    },
    async dowLoadFile({ id, fileName }) {
      const res = await apiAttachmentDownFile({ id })
      download(res.data, fileName)
    },
    async getFiles() {
      const params = {
        bizId: this.wlyApplyForGoodsPo.id,
        bizCode: this.processKey
      }
      const { data } = await queryFiles(params)
      this.gridOptions2.data = data
    },
    async getAjInfo() {
      const { data } = await apiFindAnJiOrderStatus({ wantCode: this.wlyApplyForGoodsPo.wantCode })
      this.ajInfo.data = data
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    validate(cb) {
      this.errorList = []
      this.$refs['form'].validate((valid, err) => {
        if (valid) {
          try {
            if (!this.wlyApplyForGoodsPo.subProcUnitId) {
              throw new Error('未找到审批节点！subProcUnitId：' + this.wlyApplyForGoodsPo.subProcUnitId)
            }
            if (this.wlyApplyForGoodsPo.subProcUnitId === 'base') {
              this.gridOptions.data.forEach(item => {
                if (item.baseAuditQuantity < 1) {
                  throw new Error('请输入基地协助数量！')
                } else if (item.baseAuditQuantity > item.wantQuantity - 0) {
                  throw new Error('基地协助数量不能大于本次要货数量！')
                }
              })
            }
            if (this.wlyApplyForGoodsPo.subProcUnitId === 'warZone') {
              this.gridOptions.data.forEach(item => {
                if (item.warAuditQuantity < 1) {
                  throw new Error('请输入战区协助数量！')
                } else if (item.warAuditQuantity > item.baseAuditQuantity - 0) {
                  throw new Error('战区协助数量不能大于基地协助数量！')
                }
              })
            }
            if (this.wlyApplyForGoodsPo.subProcUnitId === 'work') {
              this.gridOptions.data.forEach(item => {
                if (item.salecenterAuditQuantity < 1) {
                  throw new Error('请输入销售内勤协助数量！')
                } else if (item.salecenterAuditQuantity > item.warAuditQuantity - 0) {
                  throw new Error('销售内勤协助数量不能大于战区协助数量！')
                }
              })
            }
            cb()
          } catch (e) {
            this.errorList = [e.message]
          }
        } else {
          this.errorList = this.$utilsCommon.filterErrorMsg(err)
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.blue {
    color: rgb(45, 146, 214);
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/data-searching/deliverySearchDetail.vue